import React, { FC, useState } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  IconButton,
  Typography,
  Stack,
  Box,
  FormControlLabel,
  Grid,
  Divider,
} from '@mui/material';
import { Icon } from '@iconify/react';
import { Button, TextField, Checkbox, Label } from '../../components';
import { ISavedFilter } from '../../types';
import GridLabels from '../VehicleTabs/GridLabels';

type Props = {
  open: boolean;
  onClose: VoidFunction;
};

const ReleaseVehicleDialog: FC<Props> = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ padding: '16px 20px' }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography fontSize={18} fontWeight={700}>
            Release Vehicle
          </Typography>
          <Box>
            <IconButton size="small" sx={{ fontSize: '24px' }}>
              <Icon onClick={onClose} icon="ei:close" />
            </IconButton>
          </Box>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ minWidth: 420, padding: '0px 20px 20px', maxWidth: '460px' }}>
        <Typography fontSize={16} fontWeight={400} lineHeight="24px">
          The vehicle will be added to inventory once it is released. Please select if you would like to release the
          vehicle or cancel the order.
        </Typography>
        <Grid container spacing={2} mt={0}>
          <GridLabels
            labels={[
              { label: 'VIN', title: 'DJ8475455' },
              { label: 'Customer Name', title: 'Elsie Harper' },
            ]}
            labelSx={{ fontSize: '14px', fontWeight: '400', color: '#717171' }}
            titleSx={{ fontSize: '16px', fontWeight: '500', color: '#3E3E3E' }}
          />
        </Grid>
        <Divider sx={{ borderColor: '#EDEDED', marginTop: '10px', marginBottom: '10px' }} />
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
          <Button
            variant="outlined"
            sx={{
              fontSize: 14,
              fontWeight: 400,
              color: '#456BD9',
              borderRadius: '4px',
              textTransform: 'none',
              padding: '8px 15px',
              lineHeight: '20px',
            }}
          >
            Cancel Order
          </Button>
          <Button
            variant="contained"
            sx={{
              fontSize: 14,
              fontWeight: 400,
              color: '#fff',
              borderRadius: '4px',
              textTransform: 'none',
              padding: '8px 15px',
              lineHeight: '20px',
              border: '1px solid #456BD9',
              marginLeft: '15px',
            }}
          >
            Release Vehicle
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReleaseVehicleDialog;
